import { render, staticRenderFns } from "./Gerenciados.vue?vue&type=template&id=519f0cef&"
import script from "./Gerenciados.vue?vue&type=script&lang=js&"
export * from "./Gerenciados.vue?vue&type=script&lang=js&"
import style0 from "./gerenciados.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports